import useGenericEntityStore from '@/layouts/entity/entityStoreModule'

const { storeModule } = useGenericEntityStore('specialties')
export default storeModule
